const StepOrder = {
    CONTACT: 0,
    SEND_MESSAGE: 1,
    FINISH: 2,
};

const NavigationMap = {
    contact: StepOrder.CONTACT,
    message: StepOrder.SEND_MESSAGE,
    finish: StepOrder.FINISH,
};

const BarLabelMap = [];
BarLabelMap[StepOrder.CONTACT] = 'Details';
BarLabelMap[StepOrder.SEND_MESSAGE] = 'Submit';

export { StepOrder, NavigationMap, BarLabelMap };




// WEBPACK FOOTER //
// ./src/constants/Steps.js